var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button_corner"},[_c('div',{attrs:{"id":"comboBtn"}},[_c('el-button',{attrs:{"color":"#00D8C3","plain":""},on:{"click":_vm.cancel}},[_vm._v("取消")]),_c('el-button',{attrs:{"color":"#139BA5","type":"primary"},on:{"click":_vm.confirm}},[_vm._v("确认")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }